import React, { useEffect } from 'react';
import { Link, LinkProps, useHistory, useLocation } from 'react-router-dom';

import { TabProps } from '@material-ui/core/Tab';
import { AppBar, Tabs, Tab } from '@material-ui/core';

import {
  SupervisorAccount,
  FileCopySharp,
  Archive,
  Person,
  // Groups,
  Approval,
  SupportAgent,
} from '@mui/icons-material';

import { useKeycloak } from '@react-keycloak/web';
import TabPanel from '../TabPanel';

import { useStyles } from './styles';
import { RealmRoles } from '../../routes';

const LinkTab: React.ComponentType<TabProps & LinkProps> =
  Tab as React.ComponentType<TabProps & LinkProps>;

interface ITabs {
  [key: string]: number;
}

const tabs: ITabs = {
  '/meus-prontuarios': 0,
  '/supervisao': 1,
  '/aprovacoes': 2,
  '/prontuarios': 3,
  '/pacientes': 4,
  '/helpdesk': 5,
  // '/setores': 6,
  '/login': 0, // redirects to my-records tab
  '/': 0, // redirects to my-records tab
};

const Navbar: React.FC = () => {
  const classes = useStyles();
  const location = useLocation();
  const history = useHistory();
  const [mainTabValue, setMainTabValue] = React.useState(0);
  const {
    keycloak: { realmAccess },
  } = useKeycloak();
  const [recordTabValue, setRecordTabValue] = React.useState(
    tabs[location.pathname],
  );

  const handleMainTabChange = (
    event: React.ChangeEvent<any>,
    newValue: number,
  ) => {
    setMainTabValue(newValue);
  };

  const handleRecordTabChange = (
    event: React.ChangeEvent<any>,
    newValue: number,
  ) => {
    setRecordTabValue(newValue);
  };

  useEffect(() => {
    setRecordTabValue(tabs[location.pathname]);
  }, [location]);

  return (
    <div>
      <AppBar position="static">
        <Tabs
          value={mainTabValue}
          variant="fullWidth"
          onChange={handleMainTabChange}
          indicatorColor="primary"
        >
          <Tab
            label="Prontuários"
            id="prontuarios"
            onClick={() => history.push('/')}
          />
        </Tabs>
      </AppBar>

      <TabPanel value={mainTabValue} index={0}>
        {recordTabValue !== undefined && (
          <AppBar position="static" className={classes.root}>
            <Tabs
              value={recordTabValue}
              variant="fullWidth"
              onChange={handleRecordTabChange}
              indicatorColor="primary"
            >
              <LinkTab
                label="Meus Prontuários"
                icon={<FileCopySharp fontSize="small" />}
                component={Link}
                to="/meus-prontuarios"
                style={{
                  display: realmAccess?.roles.includes(RealmRoles.PROFESSIONAL)
                    ? ''
                    : 'none',
                }}
              />

              <LinkTab
                label="Supervisão / Preceptoria"
                icon={<SupervisorAccount fontSize="small" />}
                component={Link}
                to="/supervisao"
                style={{
                  display: realmAccess?.roles.includes(RealmRoles.SUPERVISOR)
                    ? ''
                    : 'none',
                }}
              />

              <LinkTab
                label="Aprovações"
                icon={<Approval fontSize="small" />}
                component={Link}
                to="/aprovacoes"
                style={{
                  display: realmAccess?.roles.includes(RealmRoles.APPROVER)
                    ? ''
                    : 'none',
                }}
              />

              <LinkTab
                label="Prontuários Ceapia"
                icon={<Archive fontSize="small" />}
                component={Link}
                to="/prontuarios"
                style={{
                  display: realmAccess?.roles.includes(RealmRoles.ADMIN)
                    ? ''
                    : 'none',
                }}
              />

              <LinkTab
                label="Pacientes"
                icon={<Person fontSize="small" />}
                component={Link}
                to="/pacientes"
                style={{
                  display:
                    realmAccess?.roles.includes(RealmRoles.ADMIN) ||
                    realmAccess?.roles.includes(RealmRoles.RESEARCH)
                      ? ''
                      : 'none',
                }}
              />

              <LinkTab
                label="Helpdesk"
                icon={<SupportAgent fontSize="small" />}
                component={Link}
                to="/helpdesk"
              />

              {/* <LinkTab
                label="Setores"
                icon={<Groups fontSize="small" />}
                component={Link}
                to="/setores"
                style={{
                  display: realmAccess?.roles.includes(RealmRoles.ADMIN)
                    ? ''
                    : 'none',
                }}
              /> */}
            </Tabs>
          </AppBar>
        )}
      </TabPanel>

      <TabPanel value={recordTabValue} index={0}>
        <h2 className={classes.root}>Meus Prontuários</h2>
      </TabPanel>
      <TabPanel value={recordTabValue} index={1}>
        <h2 className={classes.root}>Supervisão / Preceptoria</h2>
      </TabPanel>
      <TabPanel value={recordTabValue} index={2}>
        <h2 className={classes.root}>Aprovações</h2>
      </TabPanel>
      <TabPanel value={recordTabValue} index={3}>
        <h2 className={classes.root}>Prontuários Ceapia</h2>
      </TabPanel>
      <TabPanel value={recordTabValue} index={4}>
        <h2 className={classes.root}>Pacientes</h2>
      </TabPanel>
      <TabPanel value={recordTabValue} index={5}>
        <h2 className={classes.root}>Helpdesk</h2>
      </TabPanel>

      {/* <TabPanel value={recordTabValue} index={6}>
        <h2 className={classes.root}>Setores</h2>
      </TabPanel> */}
    </div>
  );
};

export default Navbar;
